(function (window, document) {
  'use strict';

  var ICONS = {
    verified: ['material-symbols:verified', 'badge-icon--verified', 'js.badge.verified'],
    reviewed: ['material-symbols:check-circle-rounded', 'badge-icon--reviewed', 'js.badge.reviewed'],
    partner: ['material-symbols:verified', 'badge-icon--partner', 'js.badge.partner'],
    caution: ['material-symbols:warning-rounded', 'badge-icon--caution', 'js.badge.caution'],
    none: ['ph:info', 'badge-icon--none', 'js.badge.not_verified']
  };
  var dialog;

  function esc(value) { return window.JN.esc(value == null ? '' : String(value)); }
  function t(key, vars) {
    var text = window.JN.t(key);
    Object.keys(vars || {}).forEach(function (name) {
      text = text.replace('%(' + name + ')s', function () { return vars[name]; });
    });
    return text;
  }

  function month(value) {
    if (!value) return '';
    var parts = value.split('-');
    return new Date(Date.UTC(+parts[0], +parts[1] - 1, 1)).toLocaleDateString(document.documentElement.lang || 'en',
      {month: 'short', year: 'numeric', timeZone: 'UTC'});
  }

  function row(mark, label, value) {
    var icon = mark === 'done' ? '<iconify-icon icon="ph:check-bold"></iconify-icon>'
      : mark === 'no' ? '<iconify-icon icon="ph:minus-bold"></iconify-icon>' : '';
    return '<li class="check-list__item' + (mark === 'done' ? ' is-done' : '') + '"><span class="check-list__mark" aria-hidden="true">' +
      icon + '</span><span><span class="check-list__label">' + esc(label) + '</span>' +
      (value ? '<span class="check-list__value">' + esc(value) + '</span>' : '') + '</span></li>';
  }

  function journalist(o) {
    var d = o.badge_detail || {};
    var verified = o.badge === 'verified';
    var press = d.press_card ? [d.press_card, d.press_card_valid_to ? t('js.badge.valid_to', {date: d.press_card_valid_to}) : '']
      .filter(Boolean).join(' · ') : '';
    var rows = verified ? [
      row('done', t('js.badge.identity'), d.id),
      row('done', t('js.badge.profile_work'), d.listed),
      press ? row('done', t('js.badge.press_card'), press) : '',
      d.bylines ? row('done', t('js.badge.bylines', {count: d.bylines}), '') : '',
      d.phone ? row('done', t('js.badge.phone'), d.phone) : ''
    ] : [
      row('done', t('js.badge.profile_work'), d.listed),
      row('no', t('js.badge.identity'), t('js.badge.not_checked')),
      d.phone ? row('done', t('js.badge.phone'), d.phone) : ''
    ];
    rows.push(row('', t('js.badge.member_since'), d.joined));
    var intro = t(verified ? 'js.badge.verified_intro' : 'js.badge.reviewed_intro', {name: o.first_name || ''});
    return {state: o.badge, intro: intro, rows: rows};
  }

  function client(o) {
    var d = o.badge_detail || {};
    var state = o.badge || 'none';
    var org = [d.org || t('js.badge.personal_account'), d.org_type,
      state === 'partner' ? t('js.badge.on_partner_list') : d.org_checked ? '' : t('js.badge.not_checked')]
      .filter(Boolean).join(' · ');
    var email = !d.email_domain ? t('js.badge.not_checked')
      : d.email_work ? [t('js.badge.work_email', {domain: d.email_domain}),
        d.email_confirmed ? t('js.badge.confirmed_on', {date: month(d.email_confirmed)}) : ''].filter(Boolean).join(' · ')
      : t('js.badge.personal_email', {domain: d.email_domain});
    var rows = [
      row(d.org_checked ? 'done' : 'no', t('js.badge.organisation'), org),
      row(d.email_work && d.email_confirmed ? 'done' : 'no', t('js.badge.email'), email),
      row(d.payment ? 'done' : 'no', t('js.badge.payment'), t(d.payment ? 'js.badge.confirmed' : 'js.badge.not_added')),
      d.owner ? row('', t('js.badge.owner'), d.owner) : '',
      row('', t('js.badge.member_since'), month(d.joined))
    ];
    var intro = state === 'partner' ? t('js.badge.partner_intro', {org: d.partner_name || d.org || '', year: d.partner_since || ''})
      : state === 'verified' ? (d.org ? t('js.badge.client_verified_intro', {org: d.org})
        : t('js.badge.client_email_intro', {domain: d.email_domain || ''}))
      : state === 'caution' ? t('js.badge.caution_intro')
      : t(o.own ? 'js.badge.own_none_intro' : 'js.badge.client_none_intro');
    var note = state === 'caution' && d.reason ? '<p class="badge-sheet__note"><span class="tw-font-medium">' +
      esc(t('js.badge.from_team')) + '</span> ' + esc(d.reason) + '</p>' : '';
    return {state: state, intro: intro, rows: rows, note: note};
  }

  function render(o) {
    var s = o.client ? client(o) : journalist(o);
    var icon = ICONS[s.state] || ICONS.none;
    return '<div class="sheet__head"><h2 class="badge-sheet__title" id="badge-sheet-title"><iconify-icon icon="' + icon[0] +
      '" class="' + icon[1] + '" aria-hidden="true"></iconify-icon>' + esc(t(icon[2])) + '</h2>' +
      '<button type="button" class="btn-unstyled sheet__close close-modal" aria-label="' + esc(t('js.badge.close')) +
      '"><iconify-icon icon="ph:x" aria-hidden="true"></iconify-icon></button></div>' +
      '<div class="sheet__body"><p class="badge-sheet__intro">' + esc(s.intro) + '</p>' + (s.note || '') +
      '<ul class="check-list">' + s.rows.join('') + '</ul></div>';
  }

  function open(o) {
    if (!dialog) {
      dialog = document.createElement('dialog');
      dialog.id = 'badge-sheet';
      dialog.className = 'mobile-sheet sheet badge-sheet';
      dialog.setAttribute('aria-labelledby', 'badge-sheet-title');
      document.body.appendChild(dialog);
      if (window.JN.mobileSheet) window.JN.mobileSheet.wireOne(dialog);
      dialog.addEventListener('close', function () { dialog.innerHTML = ''; });
    }
    dialog.innerHTML = render(o);
    dialog.showModal();
  }

  document.addEventListener('click', function (e) {
    var el = e.target.closest('.js-badge-sheet');
    if (!el) return;
    e.preventDefault();
    e.stopPropagation();
    open(JSON.parse(el.dataset.line));
  });

  window.JN = window.JN || {};
  window.JN.badgeSheet = { open: open };
})(window, document);
